/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function FilePdf(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M213.58936,90.2749,157.65723,34.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,32H55.99219a16.00008,16.00008,0,0,0-16,16v88a7.99989,7.99989,0,0,0,8,8H208a7.99989,7.99989,0,0,0,8-8V96.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,90.2749ZM152,96V51.31348L196.68555,96ZM64,160H48a8.00039,8.00039,0,0,0-8,8v48a8,8,0,0,0,16,0v-8h8a24,24,0,0,0,0-48Zm0,32H56V176h8a8,8,0,0,1,0,16Zm60-32H112a8.00039,8.00039,0,0,0-8,8v48a8.00039,8.00039,0,0,0,8,8h12a32,32,0,0,0,0-64Zm0,48h-4V176h4a16,16,0,0,1,0,32Zm92-40a8.00039,8.00039,0,0,1-8,8H188v12h16a8,8,0,0,1,0,16H188v12a8,8,0,0,1-16,0V168a8.00039,8.00039,0,0,1,8-8h28A8.00039,8.00039,0,0,1,216,168Z" />
    </Svg>
  );
}

export default FilePdf;
